export default "__VITE_ASSET__D7kD9a5u__"